import I18n from '../utils/I18nMessageProvider'

import PoiData from './PoiData'
import PoiRequests from './PoiRequests'

class PoiCache {

  constructor () {
    this.taData = new PoiData()  // create empty data
  }

  clearCache () {
    this.taData.clearData()
  }

  /**
   *
   * @param id {string}
   * @returns {Poi}
   */
  getPoi (id) {
    return this.taData.getPoi(id)
  }

  /**
   *
   * @returns {Array.<Poi>}
   */
  getPois () {
    return this.taData.getPois()
  }

  /**
   *
   * @param {Object} coords
   * @param {number} coords.lat
   * @param {number} coords.lng
   * @param {number} distanceKm - The distance around coords in km
   * @param {boolean} addToCache - Whether to add the result to the cache. If yes the response will be added and all the cache will be returned, otherwise only the current response will be returned
   * @param {string} lang
   * @param categories
   * @param countries
   * @returns {Promise<PoiData, string>}
   */
  requestCoords (coords, distanceKm, addToCache, lang, categories, countries = null) {
    return new Promise((resolve, reject) => {
      PoiRequests.mapCoords(coords, lang, categories, distanceKm, countries).then(
        (taData) => {
          if (taData) {
            if (addToCache) {
              this.taData.mergeWithData(taData)
            }
            resolve(taData)
            return
          }
          // console.log('No data found / request returned null')
          reject(I18n.get('tripproxy.errors.ta_generic_error'))
        },
        (error) => reject(error)
      )
    })
  }

  /**
   *
   * @param poi {Poi}
   * @param lang {string}
   * @returns {Promise<Poi, string>}
   */
  requestPoiExtraData (poi, lang) {
    return new Promise((resolve, reject) => {
      if (poi.extraData) {
        resolve(poi)
      }
      PoiRequests.extraData(poi, lang).then(
        (changedPoi) => {
          this.taData.replacePoi(changedPoi)
          resolve(changedPoi)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }

}

export default PoiCache



// WEBPACK FOOTER //
// ./src/data/PoiCache.js